import { request } from "@/utils/request";
//列表
export function listByTYpe(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/news/listByTYpe",
    params: data,
  });
}


//上级数据（新增用）
export function getLastData(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/data/list",
    params: data,
  });
}
//新增数据
export function addNew(data,config) {
  return request({
    method: "post",
    url: "/api/patrol/sys/news/add",
    data,
    config,
  });
}
//删除
export function deleteNew(data) {
  return request({
    method: "delete",
    url: "/api/patrol/sys/news/delete",
    params: data,
  });
}
//编辑
export function newsEdit(data) {
  return request({
    method: "put",
    url: "/api/patrol/sys/news/edit",
    data,
  });
}
//详情
export function newGetById(data) {
  return request({
    method: "get",
    url: "/api/patrol/sys/news/getById",
    params: data,
  });
}

//新增视频或图片
export function uploadNew(data,config) {
  return request({
    method: "post",
    url: "/api/patrol/sys/news/upload",
    data,
    config,
  });
}
